<template>
  <div class="rows mobile-cols">
    <div class="half">
      <DataGrid
          :actions-header="$t('settings.on-board.users')"
          :data-model="userGridModel"
          :data="filteredUsers"
          :selected-id="selectedUserId"
          allow-select
          @on-select="selectUserId"
          allow-edit
      />
    </div>
    <div class="half">
      <div class="data-grid-form cols">
        <DataGrid
            :data-model="eventGridModel"
            :data="assignableEvents"
            allow-select
            @on-select="toggleEventAssign"
          />
        <div>
          <button type="submit" class="button-save"
                  :disabled="!this.isUserSelected || !this.hasUnsavedChanges"
                  @click="save">
            {{ $t('generic.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGrid from '@/components/pages/partials/DataGrid';
import {mapState} from 'vuex';
import {dataAggregator, entityDataManager} from '@/assets/js/data-manipulation';
import {actions} from "@/assets/js/vue/vuex/actions";
import notification from "@/assets/js/notification";

export default {
  name: 'Notifications',
  components: {DataGrid},
  props: {
    searchToken: String,
  },
  data() {
    return {
      selectedUserId: null,
      assignableEvents: [],
      selectedUserAssignedEventIdsInitialSorted: [],
      selectedUserAssignedEventIds: []
    };
  },
  computed: {
    ...mapState(['users']),
    userGridModel() {
      return {
        headers: {
          [this.$t('settings.on-board.users-email')]: 'email',
        },
      };
    },
    filteredUsers() {
      return dataAggregator.filterListByToken(this.users, ['name', 'email'], this.searchToken);
    },
    eventGridModel() {
      return {
        headers: {
          ['']: 'assignedIcon',
          [this.$t('settings.on-board.event')]: 'eventType',
        },
        values: {
          assignedIcon: this.getAssignedIcon,
          eventType: this.getEventTypeTitle
        },
      };
    },
    isUserSelected() {
      return this.selectedUserId !== null;
    },
    hasUnsavedChanges() {
      const tempSelectedEvents = [...this.selectedUserAssignedEventIds];
      return this.selectedUserAssignedEventIdsInitialSorted.toString() !== tempSelectedEvents.sort().toString()
    }
  },
  methods: {
    async selectUserId(id) {
      if (this.selectedUserId === id) {
        return;
      }

      if (this.hasUnsavedChanges) {
        const user = this.users.find(x => x.id === id);
        const result = await this.$swal.fire({
          html: `${this.$t('settings.on-board.events.have-unsaved-changes')}<br>${this.$t('settings.on-board.events.want-to-open-user')}<b>${user.email}</b>?`,
          icon: 'warning',
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: this.$t('generic.continue'),
          cancelButtonText: this.$t('generic.cancel'),
        });
        if (!result.isConfirmed) {
          return;
        }
      }

      this.selectedUserId = id;
      this.$store.dispatch(actions.GET_USER_ASSIGNED_EVENTS, {userId: id})
          .then(events => {
            this.selectedUserAssignedEventIds = events.map(x => x.id);
            this.selectedUserAssignedEventIdsInitialSorted = [...this.selectedUserAssignedEventIds.sort()];
          })
          .catch(e => notification.error(this.$t(e.message)));
    },
    getAssignedIcon(event) {
      const result = {class: 'width-15', message: ''};

      if (this.isUserSelected) {
        const icon = this.isEventAssigned(event) ?
            'bi-check-circle-fill text-green' :
            'bi-x-circle text-danger';

        result.icon = `bi ${icon} font-size-24  px-20`;
      }

      return result;
    },
    getEventTypeTitle(event) {
      return this.$t(entityDataManager.getMessageByEvent(event.type, event.subType));
    },
    toggleEventAssign(event) {
      if (!this.isUserSelected) {
        return;
      }

      const index = this.selectedUserAssignedEventIds.indexOf(event);
      if (index < 0) {
        this.selectedUserAssignedEventIds.push(event);
      }
      else {
        this.selectedUserAssignedEventIds.splice(index, 1);
      }
    },
    isEventAssigned(event) {
      return this.selectedUserAssignedEventIds.some(x => x === event.id);
    },
    save() {
      return this.$store.dispatch(actions.SET_USER_ASSIGNED_EVENTS, {
        assignedEvents: this.selectedUserAssignedEventIds,
        userId: this.selectedUserId
      })
          .then(() => {
            this.selectedUserAssignedEventIdsInitialSorted = [...this.selectedUserAssignedEventIds.sort()];
            this.$store.dispatch(actions.GET_CURRENT_USER_ASSIGNED_EVENTS);
          })
          .catch(e => notification.error(this.$t(e.message)));
    }
  },
  mounted() {
    this.$store.dispatch(actions.GET_ASSIGNABLE_EVENTS)
        .then(events => this.assignableEvents = events)
        .catch(e => notification.error(this.$t(e.message)));
  }
};
</script>

<style scoped lang="scss">
  .data-grid-form {
    margin-top: 0;
    padding-top: 0;
  }
</style>
